






























































































   import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
   import Util from '@/lib/util';
    import AbpBase from '@/lib/abpbase';
    import SeverUrl from "@/lib/url";
    import letterData from "@/store/entities/jm/hzletterdata";
import { Message, Poptip } from 'view-design';
    @Component
  export default class HZLetterApprovals extends AbpBase {
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:String,default:''}) styname:string;
    loadingInstance:boolean=false;
    title:string ="";
    currModel:letterData=new letterData();
    selectRow=[];
    statusBtn:number=0;
    loading=false;
    get sendList(){
        return [{value:'1',text:'Email'},{value:'2',text:'传真'},{value:'3',text:'信件'},{value:'4',text:'面函'},{value:'5',text:'其它'}]
    }
    currRules={
      sendway:[{required:true,validator: this.checkSendWay,trigger:'change'}]
    }
    checkSendWay(rule, value, callback){
       if (!this.currModel.sendWay||this.currModel.sendWay=="") {
         callback(new Error('请选择发函方式'));
       }else {
         callback();
       }
    }
    visibleChange(value) {
      if (!value) {
        (this.$refs["currRef"] as any).resetFields();
        this.currModel=new letterData();
        this.selectRow=[];
        this.$emit('input',false);
      }
      else{
        this.getdata();
      }
    }
    async DownOutFile(row:any){
        let currid=this.$store.state.jobdo.currjob;
        await this.$store.dispatch({
            type:'hzletter/downOutFile',
            data:{id:row.id,projectid:currid,filename:row.fileName}
        })
    }
    cancel(){
        (this.$refs["currRef"] as any).resetFields();
        this.currModel=new letterData();
        this.selectRow=[];
        this.$emit('input',false);
    }
    async getdata(){
       this.loadingInstance=true;
       let currid=this.$store.state.jobdo.currjob;
       var response=await this.$store.dispatch({
           type:'hzletter/getall',
           data:{Id:currid,StatusId:Number(this.styname)}
       });
       if(response.length>0){
          this.currModel=Util.extend(true,{},response[0]);
          this.statusBtn=Number(this.styname);
          this.title=Number(this.styname)==2?this.currModel.projectName+">往来函证>已制函待核准":this.currModel.projectName+">往来函证>已核准待发送";
       } 
       this.loadingInstance=false;
   }
   handleSelectionChange(val) {
        this.selectRow = val;
    }
   async approval(){
    
    (this.$refs["currRef"] as any).validate(async (valid) => {
        if(valid){
          var currLine="";
          if(this.selectRow.length==0)
          {
              this.$alert('请至少勾选一项后再核准','提示',{type:'info'});
              return;
          }
          this.selectRow.forEach(element => {
                if(currLine==""){
                    currLine=element.id;
                }
                else{
                    currLine=currLine+","+element.id;
                }
            });
           this.loading=true;
           var currid=this.$store.state.jobdo.currjob;
           let response=await this.$store.dispatch({
               type:'hzletter/approvalselected',
               data:{ProjectId:currid,HzId:currLine,SendWay:this.currModel.sendWay}
           });
           if(response.success){
               this.$message({
                 message: '已核准',
                 type: 'success'
               });
               this.loading=false;
               (this.$refs["currRef"] as any).resetFields();
                this.$emit('input',false);
               this.$emit('save-success');
           }
           else{
               this.$alert(response.message,'提示',{type:'info'});
               this.loading=false;
           }
          }
    });
   }
   async send(){
       var currLine=""; 
       if(this.selectRow.length==0)
        {
            this.$alert('请至少勾选一项后再发送','提示',{type:'info'});
            return;
        }
        this.selectRow.forEach(element => {
            if(currLine==""){
                currLine=element.id;
            }
            else{
                currLine=currLine+","+element.id;
            }
        });
        this.loading=true;
        var currid=this.$store.state.jobdo.currjob;
        let response=await this.$store.dispatch({
            type:'hzletter/sendselected',
            data:{ProjectId:currid,HzId:currLine}
        });
        if(response.success){
            this.$message({
              message: '已发送',
              type: 'success'
            });
            this.loading=false;
            (this.$refs["currRef"] as any).resetFields();
            this.$emit('input',false);
            this.$emit('save-success');
        }
        else{
            this.$alert(response.message,'提示',{type:'info'});
            this.loading=false;
        }
   }
   async delall(){
        if(this.selectRow.length==0)
        {
            this.$alert('请至少勾选一项后再删除','提示',{type:'info'});
            return;
        }
        else
        {
            this.$confirm('此操作将删除已选中的函证数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(async() => {
                    let item="";
                    this.selectRow.forEach(element => {
                        if(item==""){
                            item=element.id;
                        }
                        else{
                            item=item+","+element.id;
                        }
                    });
                    if(item!=""){
                        this.loadingInstance=true;
                        let currid=this.$store.state.jobdo.currjob;
                        await this.$store.dispatch({
                            type:'hzletter/deleteselected',
                            data:{ProjectId:currid,HzId:item}
                        }); 
                        this.loadingInstance=false;
                        await this.getdata();
                    }
                }).catch(() => {                          
                });
        }  
   }
    async created(){
    }
  }
  